<template>
  <v-flex xs12>
    <v-flex xs12 v-if="title && !titleRight" class="panelTitle" :style="marginBottom ? 'margin-bottom: ' + marginBottom + ';' : '' + ' ' + paddingLeft ? 'padding-left: ' + paddingLeft + ';' : ''">{{ title }}</v-flex>
    <v-flex xs6 v-if="title && titleRight" class="panelTitle" :style="marginBottom ? 'margin-bottom: ' + marginBottom + ';' : '' + ' ' + paddingLeft ? 'padding-left: ' + paddingLeft + ';' : ''">{{ title }}</v-flex>
    <v-flex xs6 text-xs-right v-if="title && titleRight" class="panelTitle" :style="marginBottom ? 'margin-bottom: ' + marginBottom + ';' : '' + ' ' + paddingLeft ? 'padding-left: ' + paddingLeft + ';' : ''">{{ titleRight }}</v-flex>
  </v-flex>
</template>

<script>
export default {
  name: 'Headline',
  props: ['title', 'titleRight', 'marginBottom', 'paddingLeft']
}
</script>

<style scoped>
  .panelTitle {
    font-weight: bold;
    font-size: 12pt;
    font-style: normal;
    color: #004d40;
    border-bottom: 1px solid #004d40;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Headline.vue